import { GetServerSideProps } from 'next';
import CartCheckout from '@lib/CartCheckout';
import { NoodlePage } from '@typings/NextJS';
import { NoLayout } from '@layouts';

type PropsForPage = {
  creatorSlug: string;
};

type PropsFromSSR = PropsForPage;

type Params = {
  creatorSlug: string;
};

const CartPageNew: NoodlePage<PropsForPage> = ({ creatorSlug }) => <CartCheckout creatorSlug={creatorSlug} />;

CartPageNew.Layout = NoLayout;

export const getServerSideProps: GetServerSideProps<PropsFromSSR, Params> = async (context) => {
  const creatorSlug = context?.params?.creatorSlug as string;

  return {
    props: {
      creatorSlug,
    },
  };
};

export default CartPageNew;
